import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import React from "react"
import { View } from "react-native"

export const ParentSurveyContent = (props) => {
    const { question } = props

    return (
        <View style={{ padding: 20 }}>
            <OpenSansText style={{ marginTop: 10 }} fontSize={14}>
                {question}
            </OpenSansText>

            <Spacer height={60} />
        </View>
    )
}
